var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"app-loading-screen"},[_c('PLoader')],1):_c('router-view',{attrs:{"account":_vm.account}}),_c('PToast')],1)}
var staticRenderFns = []

export { render, staticRenderFns }